import { render, staticRenderFns } from "./RequestViewCard.vue?vue&type=template&id=b42df6d4"
import script from "./RequestViewCard.vue?vue&type=script&lang=js"
export * from "./RequestViewCard.vue?vue&type=script&lang=js"
import style0 from "./RequestViewCard.vue?vue&type=style&index=0&id=b42df6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports